import { createUseStyles } from 'react-jss';

const styles = {
  rightSection: {
    maxWidth: '92rem',
    margin: '0 auto',
    padding: '0 2rem',
  },
  stagesSection: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '18.8rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
